import { useMemo } from "react"
import { PagesPDFWrapper } from '../../../../../features/ui'
import { toList } from '../../../../../utils/listUtils'
import { PaymentReceiptItem } from "./types"
import { PaymentReceiptPDFPage } from "./paymentReceiptPDFPage"
import { CreditPayment } from "../../../state/types"
import { SaleOperation } from "../../../../sales"

type Props = {
    id: string
    operation?: SaleOperation
    creditPayment?: CreditPayment
}

export const PaymentReceiptPDF = (props: Props) => {
    const { id, operation, creditPayment } = props

    if (!operation && !creditPayment) return null

    const getPagesItems = (items: PaymentReceiptItem[]) => {
        const pages: PaymentReceiptItem[][] = []
        const maxPageSize = 10
        for (let i = 0; i < items.length; i += maxPageSize) {
            pages.push(items.slice(i, i + maxPageSize))
        }
        return pages
    }

    const items: PaymentReceiptItem[] = useMemo(() =>
        operation?.paymentItems.map(item => ({
            operationId: operation.id,
            paymentTypeId: item.paymentTypeId,
            creditInFavor: item.creditInFavor,
            isRounding: item.isRounding,
            amount: item.amount,
            paymentDate: item.paymentDate || operation.creationDate
        })) ||
        creditPayment?.operationItems.map(item => ({
            operationId: item.operationId,
            paymentTypeId: creditPayment.paymentTypeId,
            amount: item.amount,
            paymentDate: creditPayment.creationDate
        })) || []
    , [operation, creditPayment])

    const pagesItems = useMemo(() => getPagesItems(items), [items])

    const renderPages = pagesItems.length > 0 ?
        pagesItems.map((pageItems, index) => (_: number) => (
            <PaymentReceiptPDFPage
                key={index}
                pageIndex={index}
                dataType={operation || creditPayment!}
                items={pageItems}
                pagesAmount={pagesItems.length}
            />
        )) :
        toList(() => (
            <PaymentReceiptPDFPage
                key={0}
                pageIndex={0}
                dataType={operation || creditPayment!}
                items={[]}
                pagesAmount={1}
            />
        ))

    return (
        <PagesPDFWrapper
            id={id}
            renderPages={renderPages}
            dataType={operation || creditPayment!}
        />
    )
}
